import useSWRImmutable from 'swr/immutable'
import { endpoints, request } from '#services'
import { SendingMetaTagsError } from '#errors'

export const useMeta = ({ popId, key }) => {
  const { data, isLoading, isValidating, mutate, error } = useSWRImmutable(
    popId && key ? endpoints.meta.read({ popId, key }) : null,
    request,
  )

  const send = async (value) => {
    try {
      const response = await request(endpoints.meta.create({
        postId: popId,
        data: {
          [key]: value
        }
      }))
      
      if (response.data.success) {
        await mutate()
      }
      
      return response
    } catch (error) {
      throw new SendingMetaTagsError(error)
    }
  }

  return {
    data: data?.data?.data,
    isLoading,
    isValidating,
    mutate,
    error,
    send
  }
}
